import * as React from "react";

import ReactTable from "react-table";
import { Column } from "react-table";
import "react-table/react-table.css";

import { Container, Button, InputGroup, InputGroupAddon, Input } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPencilAlt
} from "@fortawesome/free-solid-svg-icons";

import "../scenarios/scenarios.css";
import i18n from "../i18n";
import { getAsync, postAsync } from "../utils/net";
import { checkRole, getUserName } from "../security/security";

import ScriptEdit from "./script-edit";
import { ToastsStore } from "react-toasts";

export interface ScriptsTableProps { }
export interface ScriptsTableState {
    scripts: any[];
    quickfind: string;
    loading: boolean;
    selectedItem: any;
    isNew: boolean;
    showEdit: boolean;
}

export class ScriptsTable extends React.Component<
    ScriptsTableProps,
    ScriptsTableState
> {
    private filterMethod = (filter: any, row: any) =>
        new RegExp(filter.value, "i").test(String(row[filter.id]));

    private columns: Column[] = [
        {
            Header: i18n.Scripts.Table.Scenario,
            accessor: "scenarioName"
        },
        {
            Header: i18n.Scripts.Table.ScenarioVirtualNode,
            accessor: "virtualNode"
        },
        {
            Header: i18n.Scripts.Table.ScenarioCluster,
            accessor: "category"
        },
        {
            Header: i18n.Scripts.Table.ScenarioMarket,
            accessor: "market"
        },
        {
            Header: i18n.Scripts.Table.ScenarioType,
            accessor: "scenarioType"
        },
        {
            Header: i18n.Scripts.Table.NodeId,
            accessor: "id"
        },
        {
            Header: i18n.Scripts.Table.ComponentType,
            accessor: "type"
        },
        {
            Header: i18n.Scripts.Table.Text,
            accessor: "q"
        },
        {
            Header: i18n.Scripts.Table.Speak,
            accessor: "speak"
        },
        {
            Header: i18n.Scripts.Table.TelemetryId,
            accessor: "telemetryId"
        },
        {
            id: "allowFeedback",
            Header: i18n.Scripts.Table.AllowFeedback,
            accessor: (f: any) => f.allowFeedback.toString(),
        },
        {
            Header: i18n.Global.LastEdit,
            accessor: "timestamp",
        },
        {
            Header: i18n.Scripts.Table.CheckedOutBy,
            accessor: "checkedOutBy"
        },
        {
            Header: "",
            filterable: false,
            show: checkRole("Scripts.Change"),
            maxWidth: 50,
            Cell: row => {
                const checkedOutBy = row.original.checkedOutBy;

                if (!checkedOutBy || checkedOutBy === getUserName()) {
                    return (
                        <Button
                            size="sm"
                            color="primary"
                            onClick={() => this.onEdit(row.original)}
                        >
                            <FontAwesomeIcon icon={faPencilAlt} />
                        </Button>)
                } else {
                    return
                }
            }
        },
    ];
    constructor(props: ScriptsTableProps) {
        super(props);
        this.state = {
            selectedItem: null,
            loading: false,
            isNew: false,
            scripts: [],
            quickfind: "",
            showEdit: false,
        };
    }

    // componentWillMount() {
    //    this.loadScripts();
    // }

     componentDidMount() {
        this.loadScripts();
     }

    render() {
        return (
            <Container fluid={true} className="scripts-page page">
                <h1 className="page-header">{i18n.Scripts.Title}</h1>
                <p>
                    <Button
                        color="primary"
                        size="sm"
                        onClick={() => this.download()}
                    >
                        {i18n.Scripts.Form.DownloadButton}
                    </Button>
                </p>
                <span>
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">🔍</InputGroupAddon>
                        <Input placeholder="quick find" onChange={e => this.onQuickFind(e)} />
                    </InputGroup>
                </span>
                <ReactTable
                    noDataText={this.state.loading ? "Loading" : "No items found"}
                    data={this.list}
                    filterable={true}
                    columns={this.columns}
                    defaultFilterMethod={this.filterMethod}
                    defaultPageSize={10}
                    className="-striped -highlight"
                />
                <ScriptEdit
                    item={this.state.selectedItem}
                    isOpen={this.state.showEdit}
                    isNew={this.state.isNew}
                    onCancel={model => this.onCancelEdit(model)}
                    onSave={model => this.onSave(model)}
                    scriptsList={this.state.scripts}
                />
            </Container>
        );
    }

    private async loadScripts() {
        this.setState({ loading: true });
        const reply = await getAsync("/api/designer/getscenarioscomponentslist");
        const payload = await reply.json();

        this.setState({
            scripts: payload,
            loading: false
        });
    }

    private onQuickFind(e: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            quickfind: e.target.value,
        })
    }

    private get list() {
        return this.state.scripts
            .filter(this.state.quickfind
                ? item => this.columns.some(col =>
                    this.filterMethod({ id: col.accessor, value: this.state.quickfind }, item))
                : item => true)
    }

    private async download() {
        let a = document.createElement("a");
        const reply = await getAsync("/api/designer/getscenarioscomponentslist");
        const scripts = await reply.json();
        var jsonObject = JSON.stringify(scripts);
        var csv = "Scenario Name; Component Type; Text; Speak;"
        csv += " Telemetry; Virtual Node; Cluster; Market; Type; Last Edit\r\n"
        csv += this.convertToCSV(jsonObject);

        var blob = new Blob(["\uFEFF" + csv], {
            type: "text/csv; charset=utf-8"
        });
        a.href = URL.createObjectURL(blob);
        a.download = "scripts.csv";
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    private convertToCSV(objArray: any) {
        var array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
        var str = "";
        const columns = ["virtualnode", "category", "market", "type", "scenariotype",
            "q", "speak", "telemetryid", "timestamp"];

        for (var i = 0; i < array.length; i++) {
            var name = "scenarioName";
            if (array[i][name] !== null) {
                var line = "\"" + array[i][name] + "\"";
            } else {
                line = " ";
            }
            for (var index of Object.keys(array[i])) {
                if (columns.indexOf(index.toLowerCase()) > -1) {
                    line += ";";

                    if (array[i][index] !== null) {
                        line += "\"" + array[i][index].replace(/(?:\r\n|\r|\n)/g, " ").replace(/\"/g, "\"\"") + "\"";
                    } else {
                        line += " ";
                    }
                }
            }
            str += line + "\r\n";

        }

        return str;
    }

    private async onEdit(item: any) {
        try {
            // check out the related scenarios, i.e. all those sharing the same node
            const reply = await postAsync("/api/designer/checkoutbynode", item);

            if (reply.ok) {
                const checkedOut = await reply.json();
                this.setState({ selectedItem: checkedOut, showEdit: true });
            } else {
                throw reply;
            }
        } catch (e) {
            // if e is thrown by the postAsync, it is already handled by prompting an alert with a generic error given the status code.
            // thus we avoid showing another modal window here and provide instead custom error message in a toast
            ToastsStore.error(i18n.Scripts.CheckOutError);

            this.setState({ showEdit: false, selectedItem: null }); // otherwise the edit remains opened and there's an error loop
        }
    }

    private async onCancelEdit(model: any) {
        try {
            const reply = await postAsync("/api/designer/UndoEditNode", model);
            if (reply.ok) {
                this.setState({ showEdit: false, selectedItem: null });
            } else {
                throw reply;
            }
        } catch (e) {
            // if e is thrown by the postAsync, it is already handled by prompting an alert with the status code error.
            // thus we avoid showing another modal window here and provide instead custom error message in a toast
            ToastsStore.error(i18n.Scripts.UndoEditFailure);

            this.setState({ showEdit: false, selectedItem: null }); // otherwise the edit remains opened and there's a loop
        }
    }

    private async onSave(model: any) {
        try {
            const reply = await postAsync("/api/designer/UpdateNode", model);
            if (reply.ok) {
                this.setState({ showEdit: false, isNew: false, selectedItem: null });
                this.loadScripts();
            } else {
                throw reply;
            }
        } catch (e) {
            // if e is thrown by the postAsync, it is already handled by prompting an alert with the status code error.
            // thus we avoid showing another modal window here and provide instead custom error message in a toast
            ToastsStore.error(i18n.Scripts.SaveFailure);
        }
    }

}


// WEBPACK FOOTER //
// ./src/scripts/scripts.tsx